import { detectAnyAdblocker } from 'just-detect-adblock'

export default class AdblockDetector {
    constructor(elm, args) {
        detectAnyAdblocker().then((detected) => {
            if (!document.body.classList.contains('static-premium') && detected) {
                if (window.location.href.indexOf(args.url) == -1) {
                    window.location.href = `${args.url}?fromAdblock=true`;
                }
            }
        });
    }
}
